import { consoleRoutes } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { AppLink } from "@sagot/ui";
import { useContext } from "react";
import { useWorkspaceContext } from "../../../../session/workspace-context";
import { useWorkflowSetup } from "../use-workflow-setup";
import { useRefs } from "./refs";
import { homeStarter } from "./setup-model";
import { WorkflowIdContext } from "./workflow-id-context";

const N = "engage.workflows.setup.homeNote";

function Note({ workflowId }: { workflowId: string }) {
  const { t } = useTranslation();
  const { summary } = useWorkspaceContext();
  const fallbackAgentId = useRefs().agents[0]?.id;
  const setup = useWorkflowSetup(workflowId);
  const starter = setup.data ? homeStarter(setup.data.items, fallbackAgentId) : null;
  if (!starter) return null;
  const agentId = starter.agentId;
  const text = starter.kind === "none" ? t(`${N}.none`) : t(`${N}.${starter.kind}`, { label: starter.label, agent: starter.agent });
  return (
    <p className="mt-1 text-xs text-fg-muted" data-testid="home-option-note" data-kind={starter.kind}>
      {text}
      {agentId ? (
        <>
          {" "}
          <AppLink className="font-semibold text-primary-ink underline" href={consoleRoutes.widgetStudio(summary.slug, agentId, "home")}>{t(`${N}.open`)}</AppLink>
        </>
      ) : null}
    </p>
  );
}

/** Under a `home_option` trigger: which Widget Home option starts this workflow ("Not on any Home option yet" when none does). */
export function HomeOptionNote() {
  const workflowId = useContext(WorkflowIdContext);
  return workflowId ? <Note workflowId={workflowId} /> : null;
}
